import React from 'react';

const NotFound = () => {
    return (
        <div>
            <h1>sorry there is no page found</h1>
        </div>
    );
};

export default NotFound;